import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

const classes = {
	tabButton: 'js-m-info-list__tab',
	tabPanel: 'js-m-info-list__panel',
	tabButtonActive: 'state-m-info-list__tab--active',
	tabPanelActive: 'state-m-info-list__panel--active',
};

@createModule('InfoList')
/**
 * info-list module implementation.
 *
 */
export class InfoList extends TerrificSpec {
	$ctx: JQuery;
	$tabButton: JQuery;
	$tabPanel: JQuery;

	start(resolve: () => void) {
		this.$ctx = $(this._ctx);
		this.$tabButton = $(`.${classes.tabButton}`, this.$ctx);
		this.$tabPanel = $(`.${classes.tabPanel}`, this.$ctx);

		this.initTab();
		this.$tabButton.on('click', this.onSwichTab.bind(this));

		resolve();
	}

	initTab() {
		this.$tabButton.first().addClass(classes.tabButtonActive);
		this.$tabPanel.first().addClass(classes.tabPanelActive);
	}

	onSwichTab(ev: any) {
		$(ev.currentTarget).addClass(classes.tabButtonActive);
		$(ev.currentTarget).siblings().removeClass(classes.tabButtonActive);
		this.$tabPanel.removeClass(classes.tabPanelActive)
		this.$tabPanel.eq($(ev.currentTarget).index()).addClass(classes.tabPanelActive);
	}
    
	stop() {}
}
